// extracted by mini-css-extract-plugin
module.exports = {"root":"Services_root__1v5Kz","icon_text":"Services_icon_text__2b5-r","icon_text_disabled":"Services_icon_text_disabled__1MU2R","icon":"Services_icon__2bhUO"};